<template>
  <b-container v-if="direccionSeleccionada">
    <v-card>
      <address-form
        :modo="'actualizar'"
        :direccion="direccionSeleccionada"
        @processAddress="updateAddress"
      ></address-form>
    </v-card>
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AddressForm from "@/components/addresses/AddressFormV2";
export default {
  components: {
    AddressForm
  },
  computed: {
    ...mapState("addresses", ["direccionSeleccionada"])
  },
  methods: {
    ...mapActions({
      _updateAddress: "addresses/updateAddress"
    }),
    updateAddress(address) {
      console.log("update");
      this._updateAddress(address).then(ok => {
        if (ok) {
          this.$router.push("/direcciones");
        }
        console.log("Actualizado:" + ok);
      });
    }
  }
};
</script>
